/* eslint-disable react/no-unused-state */
import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { buttons as Buttons } from '@breezeway/brzw-components';

import './modal_slide_header.scss';

class ModalSlideHeader extends Component {
  constructor(props) {
    super(props);

    this.renderHeader = this.renderHeader.bind(this);
    this.renderHeaderContent = this.renderHeaderContent.bind(this);
    this.renderTitleContent = this.renderTitleContent.bind(this);
  }

  renderTitleContent() {
    const { isMobile, withSubNav, title, onCloseModal } = this.props;
    return (
      <div className="modal-slide-header__main-header">
        <div className="modal-slide-header__title-section">
          <span className="modal-slide-header__title">{title}</span>
          {_.isFunction(onCloseModal) && (
            <Buttons.IconButton
              iconName="circle-close"
              onClick={onCloseModal}
              size={Buttons.constants.BUTTON_SIZES.ICON_X_SMALL}
              theme={Buttons.constants.BUTTON_THEMES.LINK}
              className="modal-slide-header__close"
            />
          )}
        </div>
        {isMobile && withSubNav && (
          <div className="back-button-container">
            <button
              color="link"
              className="back-button align-self-start icon-chevron-left"
              type="button"
              onClick={onCloseModal}
            >
              Back
            </button>
          </div>
        )}
      </div>
    );
  }

  renderHeaderContent() {
    const { fixedOnMobile, children, isMobile, headerFixed } = this.props;

    return (
      <div
        className={classnames('modal-slide-header', {
          'modal-slide-header--fixed': headerFixed,
        })}
      >
        {!(fixedOnMobile && isMobile) && this.renderTitleContent()}
        <div className="modal-slide-header__sub-header">{children}</div>
      </div>
    );
  }

  renderHeader() {
    const { headerFixed } = this.props;

    if (headerFixed) {
      return (
        <Fragment>
          <div className="modal-slide-header modal-slide-header--fixed-title">
            {this.renderTitleContent()}
          </div>
          {this.renderHeaderContent()}
        </Fragment>
      );
    }

    return this.renderHeaderContent();
  }

  render() {
    return this.renderHeader();
  }
}

ModalSlideHeader.propTypes = {
  children: PropTypes.node,
  headerFixed: PropTypes.bool,
  fixedOnMobile: PropTypes.bool,
  isMobile: PropTypes.bool,
  onCloseModal: PropTypes.func,
  title: PropTypes.string,
  withSubNav: PropTypes.bool,
};

ModalSlideHeader.defaultTypes = {
  fixedOnMobile: false,
  withSubNav: true,
};

const mapStateToProps = (state, props) => {
  const { fixedOnMobile, isMobile } = props;
  const headerFixed = fixedOnMobile && isMobile;

  return {
    headerFixed,
  };
};

export default connect(mapStateToProps)(ModalSlideHeader);
